import { ButtonFormTargets, ButtonTypes } from "../button/index.js";
export const FilterPillTypes = {
    ...ButtonTypes
};
export const FilterPillFormTargets = {
    ...ButtonFormTargets
};
/** Appearance values for {@link FilterPill}. */
export const FilterPillAppearances = {
    primary: "primary",
    subtle: "subtle",
    transparent: "transparent",
    outline: "outline",
    primaryOnBrand: "primary-on-brand"
};
/** Shape values for {@link FilterPill}. */
export const FilterPillShapes = {
    circular: "circular",
    square: "square"
};
/** Size values for {@link FilterPill}. */
export const FilterPillSizes = {
    small: "small",
    medium: "medium",
    large: "large"
};
/**
 * FilterPill event names
 * @public
 */
export const FilterPillEventNames = {
    pressedChange: "pressed-change"
};
//# sourceMappingURL=filter-pill.options.js.map